import React, { useEffect, useState } from "react";
import PageHeader from "src/Components/Customer/PageHeader";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { IqueryParams } from "src/types/GlobalInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import RangeSlider from "src/Components/WebsiteComponents/RangeSlider";
import { Link, useLocation } from "react-router-dom";
import SplashScreen from "src/Components/SplashScreen";
import { IPaginated } from "src/types/paginated";
import IsFavoriteComponent from "src/Components/Customer/ProductsAndServicesComponents/IsFavoriteComponent";
import testInclude from "src/assets/images/test-include.png";
import bloodSample from "src/assets/images/blood-sample.png";
import PaginationComponet from "src/Components/GlobalComponents/PaginationComponet";
import AddCartComponent from "src/Components/Customer/ProductsAndServicesComponents/AddCartComponent";
import qs from "qs";
import AddProductPrescribeModal from "src/Components/DoctorComponents/AddProductPrescribeModal";
import BackIcon from "src/assets/images/back-icon.png";
import { CURRENCY } from "src/lib/constans";
import SearchFilterInput from "src/Components/GlobalComponents/SearchFilterInput";
import PriceFilterDropdown from "src/Components/GlobalComponents/Widget/PriceFilterDropdown";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";

type TabKeys = "Test" | "Packages";
interface IProdObj {
  _id: string;
  productName: string;
  productImage: string;
  prescriptionRequired: boolean;
  isLiked: boolean;
  regularPrice: number;
  salePrice: number;
  noOfBiomarkers: number;
  testType: string;
}
interface IProductResponse {
  documents: IProdObj[];
  paginated: IPaginated;
}

interface IPackageObj {
  _id: string;
  name: string;
  image: string;
  prescriptionRequired: boolean;
  isLiked: boolean;
  regularPrice: number;
  salePrice: number;
  noOfTests: number;
}

interface IPackageResponse {
  documents: IPackageObj[];
  paginated: IPaginated;
}

const DashboardDiagnosticsProducts: React.FC = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const isPrescribe = urlParams.get("prescribe");
  const appointmentId = urlParams.get("appointmentId");
  const [prescribeProductId, setPrescribeProductId] = useState<null | string>(
    null
  );
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const tabSwitch = urlParams.get("tabSwitch") || "Test";

  const [activeTab, setActiveTab] = useState<TabKeys>("Test");
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [allProducts, setAllProducts] = useState<IProdObj[]>([]);
  const [allPackages, setAllPackages] = useState<IPackageObj[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 15,
    userId: userDetails?._id || "",
    categoryIds: ["all"],
    minPrice: 0,
    maxPrice: 1000000,
    search: "",
  }); // only for tests tab
  const [categoryStates, setCategoryStates] = useState<{
    loader: boolean;
    searchVal: string;
    isSearch: boolean;
    allCategories: { value: string; label: string }[];
  }>({
    loader: false,
    searchVal: "",
    isSearch: false,
    allCategories: [],
  });
  const handleIsLikeChanged = (obj: {
    productId: string;
    isLiked: boolean;
  }) => {
    const { productId = "", isLiked = false } = obj;
    if (activeTab === "Test") {
      setAllProducts((prev) =>
        prev?.map((v) => (v._id === productId ? { ...v, isLiked } : v))
      );
    } else {
      setAllPackages((prev) =>
        prev?.map((v) => (v._id === productId ? { ...v, isLiked } : v))
      );
    }
  };

  const handleTabClick = (tabName: any) => {
    setActiveTab(tabName);
    setQueryParams({
      page: 1,
      limit: 12,
      userId: userDetails?._id || "",
      categoryIds: ["all"],
      minPrice: 0,
      maxPrice: 10000,
    });
  };

  const fetchAllProducts = async () => {
    setIsLoader(true);
    const actualPayload = {
      ...queryParams,
      categoryIds: queryParams?.categoryIds
        .map((item: string) => (item === "all" ? "" : item))
        .filter((item: string) => item !== "")
        .join(","),
    };

    const { res, err } = await httpRequest<IProductResponse>({
      path: `/product/home/all?${qs.stringify(actualPayload)}`,
    });

    if (res) {
      setAllProducts(res?.documents);
      setPaginated(res?.paginated);
    } else {
      toast(err, { type: "error" });
    }

    setIsLoader(false);
  };

  const fetchAllPackages = async () => {
    setIsLoader(true);
    const actualPayload = {
      ...queryParams,
      categoryIds: queryParams?.categoryIds
        .map((item: string) => (item === "all" ? "" : item))
        .filter((item: string) => item !== "")
        .join(","),
    };
    const { res, err } = await httpRequest<IPackageResponse>({
      path: `/diagnostic-package/home/all?${qs.stringify(actualPayload)}`,
    });
    if (res) {
      setAllPackages(res?.documents);
      setPaginated(res?.paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    if (activeTab === "Test") {
      fetchAllProducts();
    } else {
      fetchAllPackages();
    }
  }, [queryParams]);

  useEffect(() => {
    handleTabClick(tabSwitch);
  }, [tabSwitch]);

  useEffect(() => {
    (async () => {
      setCategoryStates((prev) => ({ ...prev, loader: true }));
      const { res, err } = await httpRequest<{ _id: string; name: string }[]>({
        path: "/category",
      });
      if (res) {
        const _data = (res || [])?.map((v) => ({
          label: v?.name,
          value: v?._id,
        }));
        setCategoryStates((prev) => ({
          ...prev,
          allCategories: [
            {
              value: "all",
              label: "All",
            },
            ..._data,
          ],
        }));
      } else {
        toast(err, { type: "error" });
      }
      setCategoryStates((prev) => ({ ...prev, loader: false }));
    })();
  }, []);

  const BackButton: React.FC = () => {
    return (
      <Link
        to={`/doctor/appointment/${appointmentId}/prescribe`}
        className="right-bar-icon"
      >
        <img src={BackIcon} alt="back-icon" />
      </Link>
    );
  }; // display back icon in page header
  return (
    <>
      <div className="view-area-width-2 h-3vw">
        <AddProductPrescribeModal
          appointmentId={appointmentId}
          productId={prescribeProductId}
          productName={
            allProducts?.find((v) => v._id === prescribeProductId)
              ?.productName || ""
          }
          type="diagnostic"
          show={prescribeProductId ? true : false}
          onClose={() => setPrescribeProductId(null)}
        />
        <PageHeader
          title={activeTab === "Test" ? "All Tests" : "All Packages"}
          {...(isPrescribe
            ? { isButton: true, ButtonComponent: BackButton }
            : {})}
        />
        {isLoader && <SplashScreen />}
        <div className="dasboard-new-filter">
          <div
            id={"pharma-dasboard-bg-tem-height"}
            className="pharma-dasboard-bg-tem"
          >
            <div className="flex w-full justify-between items-center gap-2 mt-3.5">
              <div className="flex items-center gap-2 flex-1 w-fit">
                <CustomWebsiteDropdown
                  options={categoryStates?.allCategories}
                  setData={(data) => {
                    if (data.length > 0) {
                      setQueryParams((prev) => ({
                        ...prev,
                        categoryIds: data?.map((v) => v?.value),
                      }));
                    } else {
                      setQueryParams((prev) => ({
                        ...prev,
                        categoryIds: ["all"],
                      }));
                    }
                  }}
                  data={
                    categoryStates?.allCategories?.filter((v) =>
                      queryParams?.categoryIds?.includes(v?.value)
                    ) || []
                  }
                  placeholder="Filter by Category"
                  withoutMargin
                  loading={categoryStates?.loader}
                  mainDivClass="min-w-[130px] lg:min-w-[12vw] !w-fit"
                  showRadioBtn
                />
                <PriceFilterDropdown
                  setData={(data) => {
                    if (data) {
                      setQueryParams((prev) => ({
                        ...prev,
                        minPrice: data?.min || "",
                        maxPrice: data?.max || "",
                      }));
                    } else {
                      setQueryParams((prev) => ({
                        ...prev,
                        minPrice: "",
                        maxPrice: "",
                      }));
                    }
                  }}
                  data={
                    queryParams?.minPrice !== "" || queryParams?.maxPrice !== ""
                      ? {
                          min: queryParams?.minPrice,
                          max: queryParams?.maxPrice,
                        }
                      : null
                  }
                  placeholder="Filter by Price"
                  withoutMargin
                  mainDivClass="min-w-[130px] lg:min-w-[12vw] !w-fit"
                />
              </div>
              <div>
                <SearchFilterInput
                  placeHolder="Search for Products"
                  searchVal={queryParams?.search || ""}
                  onChangeText={(val) =>
                    setQueryParams((prev) => ({
                      ...prev,
                      search: val || "",
                    }))
                  }
                  inputExtraStyle={{
                    marginBottom: "0",
                  }}
                />
              </div>
            </div>
            <hr className="my-3 xs:my-4 products-tabs-hr-allOrder" />
            <div
              key={`${Math.random()}${queryParams?.categoryIds?.length}`}
              className="diagnostic-products-grid"
            >
              {activeTab === "Test" ? (
                <>
                  {allProducts.map((item) => (
                    <div key={item?._id} className="pharmacy-card-main">
                      <img
                        className="diagnostic-product-inner-img"
                        src={`${item?.productImage}`}
                        alt={""}
                      />
                      {/* <div className="Prescription-requird-main">
                        <div className="Prescription-requird">
                          {item?.prescriptionRequired ? (
                            <span className="Prescription-requird-inner-span text-white font-Poppins-Regular font-size-12px">
                              Prescription Required
                            </span>
                          ) : (
                            <span></span>
                          )}
                          {!isPrescribe && (
                            <IsFavoriteComponent
                              productId={item?._id}
                              isFav={item?.isLiked || false}
                              category="tests"
                              onSuccess={handleIsLikeChanged}
                            />
                          )}
                        </div>
                      </div> */}
                      <div className="daiganostic-product-card-content min-h-[120px] lg:min-h-[9vw]">
                        {isPrescribe ? (
                          <span>
                            <p className="theme-color-green line-clamp-2 mb-2 font-Poppins-SemiBold font-size-18px">
                              {item?.productName}
                            </p>
                          </span>
                        ) : (
                          <Link
                            to={`/customer/diagnostic-product-detail/test/${item?._id}/view`}
                          >
                            <p className="theme-color-green line-clamp-2 mb-2 font-Poppins-SemiBold font-size-18px">
                              {item?.productName}
                            </p>
                          </Link>
                        )}
                        <div className="product-card-test-include-main">
                          <div className="product-card-test-include">
                            <img src={testInclude} alt="" />
                            <span className="text[#333333] font-size-12px font-Poppins-Regular">
                              {item?.noOfBiomarkers} Tests
                            </span>
                          </div>
                          <div className="product-card-test-include">
                            <img src={bloodSample} alt="" />
                            <span className="text[#333333] font-size-12px font-Poppins-Regular">
                              {item?.testType || ""}
                            </span>
                          </div>
                        </div>
                        <div className="daiganostic-product-card-content-price">
                          <div className="sale-price-or-regular-price">
                            <span className="font-size-22px font-Poppins-Bold theme-color-green">
                              {CURRENCY} {parseFloat(item?.salePrice?.toString() || item?.regularPrice?.toString() || "0").toLocaleString()}
                            </span>
                            {item?.salePrice != null && item?.salePrice > 0 && (
                              <span className="font-size-16px line-through font-Poppins-Medium font-Poppins-Regular text-[#878787]">
                                {CURRENCY} {`${item?.regularPrice?.toLocaleString() || "-"}`}
                              </span>
                            )}
                          </div>
                          <button
                            onClick={() => setPrescribeProductId(item?._id)}
                            className="add-to-cart-products"
                          >
                            <FontAwesomeIcon
                              size="sm"
                              className="text-white"
                              icon={faPlus}
                            />
                          </button>
                          {/* {isPrescribe ? (
                            <button
                              onClick={() => setPrescribeProductId(item?._id)}
                              className="add-to-cart-products"
                            >
                              <FontAwesomeIcon
                                size="sm"
                                className="text-white"
                                icon={faPlus}
                              />
                            </button>
                          ) : (
                            <AddCartComponent
                              productId={item?._id}
                              type="diagnostic"
                              prescriptionRequired={
                                item?.prescriptionRequired || false
                              }
                              quantity={1}
                              itemType="product"
                            />
                          )} */}
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {allPackages.map((item) => (
                    <div key={item?._id} className="pharmacy-card-main">
                      <Link
                        to={`/customer/diagnostic-product-detail/package/${item?._id}/view`}
                      >
                        <img
                          className="diagnostic-product-inner-img"
                          src={`${item?.image}`}
                          alt={""}
                        />
                      </Link>
                      {/* <div className="Prescription-requird-main">
                        <div className="Prescription-requird">
                          {item?.prescriptionRequired ? (
                            <span className="Prescription-requird-inner-span text-white font-Poppins-Regular font-size-12px">
                              Prescription Required
                            </span>
                          ) : (
                            <span></span>
                          )}
                          <IsFavoriteComponent
                            productId={item?._id}
                            isFav={item?.isLiked || false}
                            category="package"
                            onSuccess={handleIsLikeChanged}
                          />
                        </div>
                      </div> */}
                      <div className="daiganostic-product-card-content min-h-[100px] lg:min-h-[8vw]">
                        <Link
                          to={`/customer/diagnostic-product-detail/package/${item?._id}/view`}
                        >
                          <p className="theme-color-green line-clamp-2 mb-2 font-Poppins-SemiBold font-size-16px">
                            {item?.name}
                          </p>
                        </Link>
                        <div className="product-card-test-include-main">
                          <div className="product-card-test-include">
                            <img src={testInclude} alt="" />
                            <span className="text[#333333] font-size-12px font-Poppins-Regular">
                              {item?.noOfTests} Tests
                            </span>
                          </div>
                        </div>
                        <div className="daiganostic-product-card-content-price">
                          <div className="sale-price-or-regular-price">
                            <strong className="font-size-18px font-Poppins-Bold theme-color-green">
                              {CURRENCY} {parseFloat(item?.salePrice?.toString() || item?.regularPrice?.toString() || "0").toLocaleString()}
                            </strong>
                            {item?.salePrice != null && item?.salePrice > 0 && (
                              <strong className="font-size-13px line-through font-Poppins-Regular text-[#878787]">
                                {CURRENCY} {`${item?.regularPrice?.toLocaleString() || "-"}`}
                              </strong>
                            )}
                          </div>
                          <AddCartComponent
                            productId={item?._id}
                            type="diagnostic"
                            prescriptionRequired={
                              item?.prescriptionRequired || false
                            }
                            quantity={1}
                            itemType="package"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
            <PaginationComponet
              currentPage={paginated.currentPage || 1}
              total={paginated.totalPages || 1}
              setCurrentPage={(_page: number) =>
                setQueryParams((prev) => ({ ...prev, page: _page }))
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardDiagnosticsProducts;
